import { BoxProps } from '@chakra-ui/react';

type WithWidth = {
  w: number;
};

type WithHeight = {
  h: number;
};

interface BaseLogoProps extends Omit<BoxProps, 'w' | 'h'> {}

type LogoPropsWithWidth = BaseLogoProps & WithWidth;

type LogoPropsWithHeight = BaseLogoProps & WithHeight;

export type LogoProps =
  | BaseLogoProps
  | LogoPropsWithWidth
  | LogoPropsWithHeight;

type CalculateWidthAndHeightBaseProps = {
  baseWidth: number;
  baseHeight: number;
};

type CalculateWidthAndHeightUsingWidth = CalculateWidthAndHeightBaseProps &
  WithWidth;

type CalculateWidthAndHeightUsingHeight = CalculateWidthAndHeightBaseProps &
  WithHeight;

export const calculateWidthAndHeight = ({
  baseWidth,
  baseHeight,
  ...props
}:
  | CalculateWidthAndHeightBaseProps
  | CalculateWidthAndHeightUsingWidth
  | CalculateWidthAndHeightUsingHeight) => {
  let ratio = 1;
  if ('w' in props && typeof props.w !== 'undefined') {
    ratio = props.w / baseWidth;
  }
  if ('h' in props && typeof props.h !== 'undefined') {
    ratio = props.h / baseHeight;
  }
  return {
    width: Math.round(baseWidth * ratio),
    height: Math.round(baseHeight * ratio),
  };
};
